import styled from 'styled-components';

export const StyledPageLayout = styled.main`
    /* Account for navigation and footer in calculation */
    min-height: calc(100vh - 33.6rem);
    /* These are technically the same, but use both for cross browser compatibility */
    overflow-wrap: break-word;
    word-wrap: break-word;
    margin-top: 5.9rem;

    @media (min-width: 64rem) {
        margin-top: 9.6rem;
    }
`;
